module.exports = __webpack_public_path__ + "static/img/video4.00f1a2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video4.jpg
// module id = gLfx
// module chunks = 0